module.exports = __webpack_public_path__ + "img/sessionmanager.973c0e1c.png";